import { Component, computed, inject, input } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { I18nService } from 'src/app/core/services/i18n.service'
import { I18nText } from 'src/app/core/interfaces/i18n.service'


@Component({
  selector: 'app-section',
  template: `
    @if (enabled()) {
      <section class="SectionBasic" data-testid="section">
          <div class="container">
            @let i18nMainText = i18n.get(mainText());
            @let i18nSubText = i18n.get(subText());
            @if (i18nMainText || i18nSubText) {
              <div
                class="SectionBasic__content"
                [style]="styles().content"
              >
                @if (i18nMainText) {
                  <h2
                    class="SectionBasic__heading"
                    [class]="mainTextSize() || 'h4'"
                  >{{i18nMainText}}</h2>
                }
                @if (i18nSubText) {
                  <div
                    class="SectionBasic__subheading body-1"
                  >{{i18nSubText}}</div>
                }
              </div>
            }
            <ng-content></ng-content>
          </div>
      </section>
    }
  `,
  styleUrls: ['./section.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatSelectModule,
    MatSlideToggleModule,
  ]
})
export class SectionComponent {
  protected i18n = inject(I18nService)

  enabled = input<boolean>(false)
  mainText = input<I18nText | string>('')
  mainTextSize = input<string>('')
  subText = input<I18nText | string>('')
  styles = input<any>({})
}
